// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd19e4d2","732":"b4a2941d"}[chunkId] + ".chunk.js";
};